import { createGlobalStyle } from 'styled-components';
import '@fontsource/montserrat/400.css';
import '@fontsource/montserrat/700.css';
import '@fontsource/poppins/400.css';
import '@fontsource/poppins/500.css';
import '@fontsource/poppins/600.css';
import '@fontsource/roboto/400.css';

const GlobalStyle = createGlobalStyle`
  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }
  
  *,
  *::before,
  *::after {
    box-sizing: border-box;
  }
  
  html,
  body,
  #root {
    width: 100%;
    overflow-x: hidden;
  }

  html {
    scroll-behavior: smooth;
    overflow-x: hidden;
    ::-webkit-scrollbar {
      width: 8px;
    }

    ::-webkit-scrollbar-track {
      background: #cececeff;
    }

    ::-webkit-scrollbar-thumb {
      background: #1B2B4D;
      border-radius: 4px;
    }

    ::-webkit-scrollbar-thumb:hover {
      background: #293d68ff;
    }
  }

  body {
    font-family: ${props => props.theme.fonts.body};
    color: ${props => props.theme.colors.black};
    background-color: ${props => props.theme.colors.white};
    line-height: ${props => props.theme.lineHeights.normal};
    overflow-x: hidden;
    width: 100%;
    min-width: 320px;
    font-size: ${props => props.theme.fontSizes.body};
    -ms-overflow-style: none;
    ::-webkit-scrollbar {
      width: 8px;
    }

    ::-webkit-scrollbar-track {
      background: #cececeff;
    }

    ::-webkit-scrollbar-thumb {
      background: #1B2B4D;
      border-radius: 4px;
    }

    ::-webkit-scrollbar-thumb:hover {
      background: #293d68ff;
    }
  }

  h1, h2, h3, h4, h5, h6 {
    font-family: ${props => props.theme.fonts.heading};
    margin-bottom: ${props => props.theme.spacing.md};
    font-weight: ${props => props.theme.fontWeights.bold};
    line-height: 1.3;
    color: ${props => props.theme.colors.primary};
  }

  h1 {
    font-size: ${props => props.theme.fontSizes.h1};
    line-height: ${props => props.theme.lineHeights.tight};
    
    @media (min-width: ${props => props.theme.breakpoints.md}) {
      font-size: ${props => props.theme.fontSizes.display};
    }
  }

  h2 {
    font-size: ${props => props.theme.fontSizes.h2};
    line-height: ${props => props.theme.lineHeights.tight};
  }

  h3 {
    font-size: ${props => props.theme.fontSizes.h3};
    font-family: ${props => props.theme.fonts.subheading};
    font-weight: ${props => props.theme.fontWeights.medium};
  }

  p {
    margin-bottom: ${props => props.theme.spacing.md};
    color: ${props => props.theme.colors.black};
    text-align: justify;
    text-justify: inter-word;
    hyphens: auto;
  }

  a {
    color: ${props => props.theme.colors.primary};
    text-decoration: none;
    transition: color 0.3s ease;
    outline-offset: 2px;

    &:hover {
      color: ${props => props.theme.colors.black};
    }
    &:focus-visible {
      outline: 3px solid ${props => props.theme.colors.primary};
    }
  }

  button {
    cursor: pointer;
  }

  section {
    padding: calc(${props => props.theme.spacing.xxl} + 0.5rem) 0;
    width: 100%;
    max-width: 100%;
  overflow-x: hidden;
  overflow-y: visible;
  scroll-margin-top: 90px;
  }

  header, footer, main {
    overflow-x: hidden;
    overflow-y: visible;
  }

  .container {
    width: 100%;
    max-width: 95%;
    margin: 0 auto;
    /* Espaçamento mínimo nas laterais em telas maiores */
    padding: 0 clamp(8px, 2vw, 24px);
    text-align: center;
    overflow-x: hidden;
  overflow-y: visible;
    
    @media (min-width: ${props => props.theme.breakpoints.md}) {
      text-align: left;
    }
    
    @media (max-width: 576px) {
      padding: 0 ${props => props.theme.spacing.md};
    }
  }

  /* Justifica textos comuns globalmente sem afetar botões/inputs */
  li, blockquote, figcaption {
    text-align: justify;
    text-justify: inter-word;
  }

  [data-animated-section] {
  overflow: hidden;
  contain: layout paint;
  }

  .fade-in,
  .slide-in-left,
  .slide-in-right,
  .scale-in {
    opacity: 0;
    transition: opacity var(--anim-duration, 0.5s) ease, transform var(--anim-duration, 0.5s) ease;
    transition-delay: var(--anim-delay, 0s);
    will-change: transform, opacity;
  }

  .fade-in {
    transform: translateY(20px);
  }
  .fade-in.visible {
    opacity: 1;
    transform: translateY(0);
  }

  .slide-in-left {
    transform: translateX(-40px);
  }
  .slide-in-left.visible {
    opacity: 1;
    transform: translateX(0);
  }

  .slide-in-right {
    transform: translateX(40px);
  }
  .slide-in-right.visible {
    opacity: 1;
    transform: translateX(0);
  }

  .scale-in {
    transform: scale(0.95);
  }
  .scale-in.visible {
    opacity: 1;
    transform: scale(1);
  }
`;

export default GlobalStyle;
